<template>
    <div>
        <div class="mb-3">
            <label class="form-label">Texto</label>
            <input class="form-control" type="text" :value="modelValue.text"
                @input="update('text', $event.target.value)">
        </div>
        <div class="row">
            <div class="col-md-4 mb-3">
                <label class="form-label">Tag</label>
                <select class="form-select" :value="modelValue.tag" @change="update('tag', $event.target.value)">
                    <option value="h1">H1</option>
                    <option value="h2">H2</option>
                    <option value="h3">H3</option>
                </select>
            </div>
            <div class="col-md-4 mb-3">
                <label class="form-label">Color</label>
                <div class="d-flex gap-2 align-items-center">
                    <input class="form-control" type="text" :value="modelValue.color"
                        @input="update('color', $event.target.value)">
                    <input class="form-control form-control-color" type="color"
                        :value="modelValue.color || '#111827'"
                        @input="update('color', $event.target.value)">
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <label class="form-label">Font size</label>
                <input class="form-control" type="text" :value="modelValue.fontSize"
                    @input="update('fontSize', $event.target.value)">
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="form-label">Font family</label>
                <input class="form-control" type="text" :value="modelValue.fontFamily"
                    @input="update('fontFamily', $event.target.value)">
            </div>
            <div class="col-md-6 mb-3">
                <label class="form-label">Line height</label>
                <input class="form-control" type="text" :value="modelValue.lineHeight"
                    @input="update('lineHeight', $event.target.value)">
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="form-label">Alineacion</label>
                <select class="form-select" :value="modelValue.align" @change="update('align', $event.target.value)">
                    <option value="left">Izquierda</option>
                    <option value="center">Centro</option>
                    <option value="right">Derecha</option>
                </select>
            </div>
            <div class="col-md-6 mb-3">
                <label class="form-label">Padding</label>
                <input class="form-control" type="text" :value="modelValue.padding"
                    @input="update('padding', $event.target.value)">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MailingBlockTitleEditor',
    props: {
        modelValue: { type: Object, default: () => ({}) },
    },
    emits: ['update:modelValue'],
    methods: {
        update(key, value) {
            this.$emit('update:modelValue', { ...this.modelValue, [key]: value });
        },
    },
};
</script>
